import { Stack, Typography, useTheme } from "@mui/material";

import { RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";

export const Section3 = ({ methods }: any) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        flex: 1,
        minWidth: { xs: "100%", sm: "48%" },
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 1,
        flexDirection: "column",
        p: 2,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}>
        {Strings.step.carInfo.accidentAndServiceHistory}
      </Typography>
      <Stack flex={1} justifyContent={"space-evenly"}>
        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ xs: "start", md: "center" }}
        >
          <Typography>{Strings.step.carInfo.accidentHistory}</Typography>
          <Stack
            flexDirection={"row"}
            flexWrap={"wrap"}
            width={{ xs: "100%", md: "auto" }}
            justifyContent={"space-between"}
          >
            <RHFRadioSingle
              name={"carInfo.accidentAndService.accidentHistory"}
              value={Strings.step.carInfo.accidentFree}
              label={Strings.step.carInfo.accidentFree}
            />
            <RHFRadioSingle
              name={"carInfo.accidentAndService.accidentHistory"}
              value={Strings.step.carInfo.minor}
              label={Strings.step.carInfo.minor}
            />
            <RHFRadioSingle
              name={"carInfo.accidentAndService.accidentHistory"}
              value={Strings.step.carInfo.major}
              label={Strings.step.carInfo.major}
            />
          </Stack>
        </Stack>
        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ xs: "start", md: "center" }}
        >
          <Typography>{Strings.step.carInfo.fullServiceRecords}</Typography>
          <Stack
            flexDirection={"row"}
            flexWrap={"wrap"}
            width={{ xs: "100%", md: "auto" }}
            justifyContent={"space-between"}
          >
            <RHFRadioSingle
              name={"carInfo.accidentAndService.fullServiceRecords"}
              value={Strings.step.carInfo.yes}
              label={Strings.step.carInfo.yes}
            />
            <RHFRadioSingle
              name={"carInfo.accidentAndService.fullServiceRecords"}
              value={Strings.step.carInfo.no}
              label={Strings.step.carInfo.no}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
